import { connect } from 'react-redux';
import  { selectors } from '@amplement/backend-connector';

import { updateAndPatchUser } from 'actions/session';
import { getSoundsStatusSelector, getCurrentUserIdSelector } from 'selectors/user';

import Component from './index';

const mapStateToProps = (state, { id }) => {
    const _me = getCurrentUserIdSelector(state);
    const feed = selectors.feeds.feedByIdSelector(state, id);
    const soundFeeds = getSoundsStatusSelector(state)?.feeds;
    const isMuted = soundFeeds?.[id] === false;
    const { name, color, unreadCount } = feed || {};
    const isAdmin = selectors.feeds.isFeedAdministratorById(id, _me)(state);

    return ({
        isMuted,
        name,
        color,
        unreadCount,
        isAdmin
    });
};

const mapDispatchToProps = (dispatch) => ({
    onMute: (id, isSoundEnabled) => dispatch(updateAndPatchUser('settings', {
        sounds: { feeds: { [id]: isSoundEnabled } } })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
